import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiJobArchivingReason,
  ApiJobArchivingReasonPayload,
} from "@/types/recruit/job-archiving-reason.types.ts";

export const apiJobArchivingReasons = {
  getAll: () => {
    return api.get<ApiJobArchivingReason[]>("/api/v1/job-archiving-reasons");
  },
  create: (payload: ApiJobArchivingReasonPayload) => {
    return api.post<ApiJobArchivingReason>("/api/v1/job-archiving-reasons", payload);
  },
  update: (id: number, payload: ApiJobArchivingReasonPayload) => {
    return api.put<ApiJobArchivingReason>(`/api/v1/job-archiving-reasons/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/job-archiving-reasons/${id}`);
  },
};
